import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const MicrophoneIcon: React.FC<IconProps> = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 15C13.66 15 15 13.66 15 12V6C15 4.34 13.66 3 12 3S9 4.34 9 6V12C9 13.66 10.34 15 12 15ZM19 12C19 16 15.87 19.3 12 19.92V22H12V24H12V22H12V19.92C8.13 19.3 5 16 5 12H7C7 15.31 9.69 18 12 18S17 15.31 17 12H19Z" />
  </svg>
);

export const SubtitlesIcon: React.FC<IconProps> = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M7 15h4M13 15h4M7 11h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const PauseIcon: React.FC<IconProps> = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <rect x="6" y="4" width="4" height="16" rx="1" />
    <rect x="14" y="4" width="4" height="16" rx="1" />
  </svg>
);

export const RestartIcon: React.FC<IconProps> = ({ size = 24, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20C9.49 20 7.27 18.87 5.81 17.1L7.23 15.68C8.31 16.95 9.98 17.75 12 17.75C15.17 17.75 17.75 15.17 17.75 12C17.75 8.83 15.17 6.25 12 6.25C8.83 6.25 6.25 8.83 6.25 12H8L5 15L2 12H4Z" />
  </svg>
);
